import React, { useState, useEffect } from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {closeDrawer} from '../../actions/drawerActions';
import {deleteQuestionnaire} from "../../actions/questionnaireTemplateActions";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ArgoToolbarHook from "../common/ArgoToolbarHook";
import ArgoTextFieldHook from "../common/ArgoTextFieldHook";
import * as TEMPLATE from "../../constants/templateConstants";


const QuestionnaireDeleteDraftDrawer = (props) => {
    // State management using useState hooks
    const [notes, setNotes] = useState("");
    const [noteErrorText, setNoteErrorText] = useState(" ");

    // Function to check for validation errors on the page
    const checkForErrorsOnPage = () => {
        // Remove spaces to ensure there is a note, DELETE Button will be disabled until there are no errors on the page
        let errorText = " ";
        if (notes.trim().length <= 0) {
            errorText = "Delete note required";
        }
        setNoteErrorText(errorText);
    };

    // Effect hook to run validation on component mount
    useEffect(() => {
        checkForErrorsOnPage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notes]); // Re-run validation when notes change

    // Handle toolbar button clicks (DELETE/CANCEL)
    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        switch (buttonTitle) {
            case "DELETE":
                props.deleteQuestionnaire(props.deleteDrawerTemplate.id, {notes: notes}, props.deleteDrawerTemplate.templateKey, props.filter, props.versionsFilter);
                break;
            case "CANCEL":
                props.closeDrawer();
                break;
            // no default
        }
    };

    // Handle text input changes
    const onTextChange = (event, fieldName) => {
        setNotes(event.target.value);
        // Validation will run automatically via useEffect dependency on notes
    };

    return (
        <div>
            <ArgoAppBarHook
                title={"Delete Draft:"}
                titleFor={props.deleteDrawerTemplate.name}
                qualifierFor={props.deleteDrawerTemplate.nameQualifier}
                showMenuIconButton={false}
                noIcon={true}
                isDrawer={true}
                width={questionnaireDeleteDraftDrawerProps.width}
            />

            <div style={{height: '64px'}}></div>

            <ArgoToolbarHook
                fileName="QuestionnaireDeleteDraftDrawer"
                fieldName="delete-or-cancel"
                buttonTitles={["DELETE", "CANCEL"]}
                onClick={handleToolbarButtonClick}
                toolbarErrorText={noteErrorText}
                width={questionnaireDeleteDraftDrawerProps.width}
            />

            <div id="QuestionnaireDeleteDraftDrawer-page-div"
                 style={{height: "100%", paddingLeft: "30px", paddingRight: "30px", marginTop: "64px"}}>
                <ArgoTextFieldHook
                    fileName="QuestionnaireDeleteDraftDrawer"
                    fieldName="notes"
                    label="Notes *"
                    value={notes}
                    multiline={true}
                    autoFocus={true}
                    onChange={onTextChange}
                    errorText={noteErrorText}
                />
            </div>
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        closeDrawer: bindActionCreators(closeDrawer, dispatch),
        deleteQuestionnaire: bindActionCreators(deleteQuestionnaire, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        deleteDrawerTemplate: state.openCloseSecondaryDrawer.template,
        filter: state.filter["questionnaires"],
        versionsFilter: state.filter[TEMPLATE.FILTER.versions.questionnaire]
    };
}

const questionnaireDeleteDraftDrawerProps = {
    opensecondary: true,
    width: "50%",
    docked: false,
    anchor: "right"
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireDeleteDraftDrawer);
export {questionnaireDeleteDraftDrawerProps};
